var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('v-app',[_c('desktop-system-bar'),_c('router-view'),_c('app-user-message')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }